/**
 * The three stagger arrangements.
 *
 * MIRRORS PHP: `render.php` holds the same values and the same fallback. Two
 * runtimes, no shared module — the editor needs it as an ES module and the
 * renderer needs it before any JS runs. Change one, change the other. Same
 * posture as `Notice/notice-types.js`.
 */

import { __ } from '@wordpress/i18n';

// Kept equal to block.json's `stagger` default, so a block with the attribute
// missing renders the same as a freshly inserted one.
export const DEFAULT_STAGGER = 'alternating';

export const STAGGER_MODES = [
  { label: __('Alternating', 'brandy-blocks'), value: 'alternating' },
  { label: __('Descending', 'brandy-blocks'), value: 'descending' },
  { label: __('None', 'brandy-blocks'), value: 'none' },
];

export const clampStagger = (value) =>
  STAGGER_MODES.some((mode) => mode.value === value) ? value : DEFAULT_STAGGER;
